/** A sandboxed activity frame can own focus while its parent reports hasFocus=false. */
export function focusDeparture(
  visibility: string,
  hasFocus: boolean,
  activityFrameFocused: boolean,
): "hidden" | "blur" | null {
  if (visibility === "hidden") return "hidden";
  if (hasFocus || activityFrameFocused) return null;
  return "blur";
}

/**
 * Browser UI, native selects, virtual keyboards and sandboxed iframes can
 * transiently blur the page. A departure is only actionable if it survives
 * this confirmation window.
 */
export const FOCUS_DEPARTURE_GRACE_MS = {
  hidden: 900,
  blur: 1800,
} as const;

export function focusDepartureDelay(reason: "hidden" | "blur") {
  return FOCUS_DEPARTURE_GRACE_MS[reason];
}


export function shouldMonitorWindowBlur(
  coarsePointer: boolean,
  maxTouchPoints: number,
) {
  return !coarsePointer && maxTouchPoints <= 0;
}
